import {Injectable} from '@angular/core';
import {Conversation} from '../../domain/conversation';
import {GenericService} from '../../../core/commons/generic.service';
import {AuthService} from '../../../core/security/auth.service';
import {QueryOptions} from '../../../core/commons/query.options';
import {BaseRequestOptions, RequestMethod, RequestOptions, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {User} from '../../../core/domain/user';
import {Subject} from 'rxjs/Subject';
import {MessageService} from './message.service';
import {Message} from '../../domain/message';
import {StompService} from '@stomp/ng2-stompjs';
import {isUndefined} from 'util';
import { environment } from 'environments/environment';
import { MessagingService } from 'app/home/service/messaging.service';

@Injectable()
export class ConversationService extends GenericService<Conversation> {

    public user: User;
    private conversationList: Conversation[] = [];
    private conversationListSubject: Subject<Conversation[]> = new Subject();
    private ws;
    private conversationSelected: Conversation = null;

    constructor(authService: AuthService,
                public messageService: MessageService,
                private messagingService: MessagingService,
                private stompService: StompService) {
        super(authService);
    }

    protected valueToEntity(value: Object): Conversation {
        return new Conversation(value);
    }

    protected getResourcePath(): string {
        return '/chat';
    }

    protected downloadPathPdf(): string {
        return '/message'
    }

    public getDefaultQueryOptions(): QueryOptions {
        return new QueryOptions();
    }

    /**
     * Devuelve un observable de la lista de conversaciones del usuario.
     * @returns Observable<Conversation[]>
     */
    public subscribeConversationList(): Observable<Conversation[]> {
        return this.conversationListSubject.asObservable();
    }

    /**
     * Envia una lista de conversaciones del usuario por el observable conversationListSubject
     */
    public getConversationList(): void {
        this.conversationListSubject.next(this.conversationList);
    }

    public setUserAndConversations(u: User): void {
        this.user = u;
        this.findConversationsByUser(this.user.id, 1000, 0)
            .subscribe(c => {
                this.conversationList = c;
                this.conversationList.forEach(c => {
                    c.participants = c.participants.filter(u => u.id != this.user.id)
                });

                this.ws = this.stompService.subscribe('/conversations/' + this.user.id);
                this.ws.map(c => new Conversation(JSON.parse(c.body)))
                    .subscribe(c => {
                        (<Conversation> c).participants = (<Conversation> c).participants.filter(u => u.id != this.user.id);
                        this.refreshConversationList(c);
                    });

                this.getConversationList();
            }); //TODO: no traer todas las conversaciones, ir paginando;
    }

    public addConversation(c: Conversation): void {
        this.conversationList.unshift(c);
        this.getConversationList();
    }

    public refreshConversationList(c: Conversation, msgTime: number = null): void {
        if (this.conversationSelected && ( this.conversationSelected.id == c.id )) {
            this.conversationList = this.conversationList.filter(conversation => c.id != conversation.id);
        } else {
            this.conversationList.forEach( ( conversation, index, array ) => {
                if ( conversation.id == c.id ) {
                    c.unreadedMessages = conversation.unreadedMessages + 1;
                    array.splice(index, 1);
                }
            });
        }

        if (msgTime)
            c.lastMessageTime = msgTime;
        this.addConversation(c);
    }

    public updateViewedNotifications() {
        this.messagingService.setViewedConversation(this.conversationSelected.id);
    }

    public sendMessage(m: Message): Observable<Message> {
        return this.messageService.create(m);
    }

    public getMessagesPage(c: Conversation, page: number): Observable<Message[]> {
        return this.messageService.getMessagesByConversation(c, 25, page);
    }


    public getLatestMessages(c: Conversation): Observable<Message[]> {
        return this.messageService.getMessagesByConversation(c, 25, 0);
    }


    public findConversationsByUser(userId: number, pagesize: number, page: number) {
        const reqOptions = new BaseRequestOptions();
        reqOptions.method = RequestMethod.Get;
        return this.authService.authRequest(this.baseUrl + this.getResourcePath() + '/' + userId + '/' + pagesize + '/' + page, reqOptions)
            .map(res => res.json().content.map(t => this.valueToEntity(t)));
    }

    public filterConversations(searchTerm: string): Conversation[] {
        if (searchTerm == '')
            return this.conversationList;
        return this.conversationList.filter(c =>
            c.participants.filter(p =>
                p.firstname.toLowerCase().concat(' ').concat(p.lastname.toLowerCase()).includes(searchTerm.toLowerCase())
            ).length > 0)
    }

    public setSelectedConversation(c: Conversation): void {
        this.conversationSelected = c;
        this.messagingService.currentConversationId.next(c.id);
        this.clearUnreadedMessages(this.conversationSelected);
    }

    public unsetSelectedConversation(): void {
        this.conversationSelected = null;
        this.messagingService.currentConversationId.next(null);
    }

    public clearUnreadedMessages(c: Conversation): void {
        this.conversationList.forEach(conversation => {
            if (conversation.id == c.id)
                conversation.unreadedMessages = 0
        })
    }

    public downloadPDF(messageId: number): Observable<any> {
       /* const headers = new Headers();
        headers.set('Accept', 'application/pdf');
        */
        return this.doRequest({
            url: this.baseUrl + this.getResourcePath() + '/message/' + messageId,
            method: RequestMethod.Get,
            responseType: ResponseContentType.Blob
        })
            .map(res => new Blob([res.blob()], {type: 'application/pdf'}))
    }

    public downloadImage(messageId: number): Observable<any> {
        /* const headers = new Headers();
         headers.set('Accept', 'application/pdf');
         */
         return this.doRequest({
             url: this.baseUrl + this.getResourcePath() + '/message/image/' + messageId,
             method: RequestMethod.Get,
             responseType: ResponseContentType.Blob
         })
             .map(res => new Blob([res.blob()], {type: 'image/jpg'}))
     }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/service/chat/conversation.service.ts